import React from "react";

export default function Backgrounds({ data }) {
  return (
    <>
      {data.background_image ? (
        <img
          alt="bg"
          src={data.background_image}
          style={{
            width: "100%",
            height: "100%",
            position: "absolute",
            objectFit: "cover",
            top: "0px",
            left: "0",
          }}
        />
      ) : null}
      {data.fading_background_2 ? (
        <img
          alt="fading bg2"
          src={data.fading_background_2.src}
          style={{
            width: "100%",
            height: "100%",
            position: "absolute",
            zIndex: 0,
            top: "0px",
            left: "0",
            opacity: 0,
            objectFit: "cover",
            animation: data.fading_background_2.animation,
          }}
        />
      ) : null}
      {data.fading_background ? (
        <img
          alt="fading bg"
          src={data.fading_background.src}
          style={{
            width: "100%",
            height: "100%",
            position: "absolute",
            zIndex: 1,
            top: "0px",
            left: "0",
            opacity: 0,
            objectFit: "cover",
            animation: data.fading_background.animation,
          }}
        />
      ) : null}
    </>
  );
}
